import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../utils/dateUtils';
import CaseTicketService from './CaseTicketService';
import { ISSUE_TYPE_LABELS, STATUS_LABELS, STATUS_BADGE_STYLES } from './constants';

// Surfaces this customer's past case tickets on their profile page, so an admin
// picking up the phone with a repeat customer already knows what happened before.
// Renders nothing at all (no header, no box) for customers with no history.
const CustomerCaseHistory = ({ customerId }) => {
  const navigate = useNavigate();
  const [cases, setCases] = useState([]);

  useEffect(() => {
    if (!customerId) { setCases([]); return; }
    CaseTicketService.getCaseTickets({ customerId })
      .then((res) => setCases(res.data))
      .catch(() => setCases([]));
  }, [customerId]);

  if (!customerId || cases.length === 0) return null;

  return (
    <div className="mt-2 bg-gray-200 px-6 py-4 overflow-y-auto max-h-full">
      <div className="bg-white shadow-lg rounded-md px-6 py-4 mb-4">
        <h3 className="font-bold mb-2">ประวัติเคสลูกค้า</h3>
        <div className="flex flex-col gap-2">
          {cases.map((c) => (
        <div key={c.id} onClick={() => navigate(`/case-ticket/${c.id}`)}
          className="border border-gray-200 rounded-lg p-3 flex flex-wrap items-center gap-2 cursor-pointer hover:bg-gray-50">
          <span className="font-semibold text-sm">#{c.id}</span>
          <span className="bg-orange-100 text-orange-700 text-xs px-2 py-0.5 rounded-full font-medium">
            {ISSUE_TYPE_LABELS[c.issueType] || c.issueType}
          </span>
          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${STATUS_BADGE_STYLES[c.status] || 'bg-gray-100 text-gray-700'}`}>
            {STATUS_LABELS[c.status] || c.status}
          </span>
          <span className="text-gray-500 text-sm truncate max-w-md">{c.description}</span>
          <span className="text-gray-400 text-xs ml-auto whitespace-nowrap">
            แจ้งเมื่อ {formatDate(c.reportedDate || c.createdAt)}
          </span>
        </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerCaseHistory;
